<template>
  <div class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white z-50 bg-opacity-50">
    <div class="paywall-container">
      <img
        class="absolute left-0 top-0 w-full h-full object-cover blurry-background select-none pointer-events-none"
        src="../../assets/images/api-paywall-background.jpg"
      >
      <PaywallCard
        v-if="subscriptionType.isLegacy"
        class="upgrade-modal"
        :subscription-type="subscriptionType"
        :upgrade-benefits="upgradeBenefits"
        upgrade-header="Upgrade your account to unlock the Data API."
        upgrade-copy="Upgrade from your legacy subscription to unlock access to the Data API."
        :learn-more="'Learn more about the Data API'"
      />
      <div
        v-else
        class="paywall-card"
        style="width: 480px; height: 430px"
      >
        <div class="rounded-2xl overflow-hidden flex items-center justify-center relative w-full h-32 bg-background-normal">
          <!-- Floaters -->
          <div class="absolute left-12 -top-1 bg-background-hover rounded-md p-2.5">
            <img
              src="https://publicassets.foreplay.co/api-integrations/gumloop.png"
              class="w-6 h-6"
            >
          </div>
          <div class="absolute right-6 -top-1 bg-background-hover rounded-md p-2.5">
            <img
              src="https://publicassets.foreplay.co/api-integrations/clay.png"
              class="w-6 h-6"
            >
          </div>
          <div class="absolute left-24 -bottom-1 bg-background-hover rounded-md p-2.5">
            <img
              src="https://publicassets.foreplay.co/api-integrations/latitude.png"
              class="w-6 h-6"
            >
          </div>
          <div class="absolute right-16 -bottom-1 bg-background-hover rounded-md p-2.5">
            <img
              src="https://publicassets.foreplay.co/api-integrations/pickaxe.png"
              class="w-6 h-6"
            >
          </div>
          <!-- free credit card -->
          <div class="px-4 py-3 rounded-xl bg-white flex gap-1.5 items-center shadow-sm">
            <img
              src="../../assets/icons/api-token.png"
              class="w-6 h-6"
            >
            <BaseText
              type="label"
              class="font-bold"
            >
              {{ freeCredits }}
            </BaseText>
          </div>
        </div>
        <div class="p-5 space-y-2">
          <BaseText
            class="text-text-muted"
            type="heading"
            size="sm"
          >
            Test the Foreplay API with <span class="text-secondary-green-100">{{ freeCredits }} credits for free</span>
          </BaseText>
          <BaseText
            size="sm"
            class="text-text-normal"
          >
            Enable access to the Foreplay API for free
          </BaseText>
        </div>
        <!-- Benefits -->
        <div class="p-5">
          <BaseText
            type="label"
            size="sm"
            class="text-text-normal mb-2.5"
          >
            What you get when unlocking:
          </BaseText>
          <div
            v-for="(benefit, index) in upgradeBenefits"
            :key="index"
            class="flex items-center gap-1.5"
          >
            <NewCheckmarkIcon class="text-secondary-green-100" />
            <BaseText
              size="md"
              class="text-text-muted"
            >
              {{ benefit }}
            </BaseText>
          </div>

          <button
            class="black-btn-primary text-white rounded-md w-full flex items-center justify-center py-1.5 px-3 mt-5"
            @click="unlockAPI"
          >
            <BaseLoadingSpinnerCircle
              v-if="loading.unlockAPI"
              class="w-5 h-5"
            />
            <BaseText
              v-else
              type="label"
              size="sm"
            >
              Unlock Access & Get Free Credits
            </BaseText>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForeplayAPI from '@/api/foreplayServer'
// Components
import PaywallCard from '../account/PaywallCard.vue'
// Icons
import NewCheckmarkIcon from '../globals/Icons/NewCheckmarkIcon.vue'
export default {
  name: 'ApiPaywallState',
  components: {
    PaywallCard,
    NewCheckmarkIcon
  },
  props: {
    subscriptionType: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    const freeCredits = this.subscriptionType.intervalType === 'year' ? '20,000' : '10,000'
    return {
      freeCredits,
      upgradeBenefits: [
        `${freeCredits} Free API credits`,
        'Access to all endpoints & AI workflows',
        'Access to all integrations'
      ],
      loading: {
        unlockAPI: false
      }
    }
  },
  methods: {
    openDemoBook () {
      window.open('https://www.foreplay.co/book-demo', '_blank')
    },
    async unlockAPI () {
      try {
        this.loading.unlockAPI = true
        const { data } = await ForeplayAPI.Subscription.createAPISubscription({
          operationType: 'create'
        })
        this.$emit('unlock', data)
        this.$showAlert({ type: 'success', message: 'API access unlocked' })
      } catch (e) {
        console.log(e.response)
        const errMessage = e.response?.data?.message
        this.$showAlert({
          type: 'error',
          message: errMessage || 'Unable to unlock API access'
        })
      } finally {
        this.loading.unlockAPI = false
      }
    }
  }
}
</script>

<style>
.paywall-container{
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.paywall-card{
  border-radius: 20px;
  background-color: white;
  box-shadow: 0 24px 32px -12px rgba(53, 57, 75, 0.24), 0 1px 2px 0 rgba(162, 172, 186, 0.16), 0 0 0 1px rgba(0, 56, 108, 0.08);
  backdrop-filter: blur(5px);
  padding: 4px;
  z-index: 10;
}

.blurry-background{
  filter: blur(8px);
  height: calc(100% + 52px);
  -webkit-filter: blur(8px);
}
</style>
